var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6582 15.8333C50.7512 16.4367 53.5938 17.9494 55.8221 20.1778C58.0504 22.4061 59.5631 25.2486 60.1665 28.3416M47.6582 3.16663C54.0842 3.88051 60.0766 6.75818 64.6513 11.3272C69.226 15.8961 72.1112 21.8848 72.8332 28.31M69.6665 53.58V63.08C69.6701 63.9619 69.4895 64.8348 69.1362 65.6429C68.7828 66.451 68.2647 67.1763 67.6148 67.7725C66.9649 68.3687 66.1977 68.8227 65.3622 69.1052C64.5268 69.3877 63.6416 69.4927 62.7632 69.4133C53.0188 68.3545 43.6587 65.0248 35.4349 59.6916C27.7837 54.8297 21.2968 48.3428 16.4349 40.6916C11.0831 32.4304 7.75264 23.0248 6.7132 13.2366C6.63407 12.3609 6.73814 11.4784 7.01879 10.6451C7.29943 9.81184 7.75051 9.04614 8.3433 8.39676C8.93608 7.74738 9.65758 7.22854 10.4619 6.87328C11.2662 6.51802 12.1356 6.33412 13.0149 6.33329H22.5149C24.0517 6.31817 25.5415 6.86237 26.7068 7.86448C27.872 8.86658 28.6331 10.2582 28.8482 11.78C29.2492 14.8202 29.9928 17.8053 31.0649 20.6783C31.4909 21.8117 31.5831 23.0435 31.3306 24.2277C31.078 25.412 30.4913 26.499 29.6399 27.36L25.6182 31.3816C30.1261 39.3095 36.6903 45.8737 44.6182 50.3816L48.6399 46.36C49.5009 45.5086 50.5879 44.9218 51.7721 44.6693C52.9563 44.4167 54.1881 44.5089 55.3215 44.935C58.1946 46.007 61.1797 46.7507 64.2199 47.1516C65.7581 47.3686 67.163 48.1434 68.1672 49.3287C69.1715 50.5139 69.7051 52.0269 69.6665 53.58Z",
    stroke: "#E7AC15",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.24f40ecf32446db7d8c32da2385ec2b4.svg";
export { ForwardRef as ReactComponent };